import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	planTitleHeading: {
		id: 'inactive-plans-directory-base.plans-table.header.plan-title-heading',
		defaultMessage: 'Title',
		description: 'Heading for plan Title column',
	},
	planCreatorHeading: {
		id: 'inactive-plans-directory-base.plans-table.header.plan-creator-heading',
		defaultMessage: 'Lead',
		description: 'Heading for plan Creator column',
	},
	planLeadHeading: {
		id: 'inactive-plans-directory-base.plans-table.header.plan-lead-heading',
		defaultMessage: 'Lead',
		description: 'Heading for plan lead column',
	},
	planArchivedOnHeading: {
		id: 'inactive-plans-directory-base.plans-table.header.plan-archived-on-heading',
		defaultMessage: 'Archived on',
		description: 'Heading for Archived On column',
	},
	planDeletedOnHeading: {
		id: 'inactive-plans-directory-base.plans-table.header.plan-deleted-on-heading',
		defaultMessage: 'Moved to trash on',
		description: 'Heading for Deleted On column',
	},
});
